$(window).on('load', () => {
    const descriptorImageCards = $('.descriptor-image-card');
    descriptorImageCards.each(function (index) {
        const descriptor = $(this);
        const descriptorImage = descriptor.find('.descriptor-image');
        const descriptorBtn = descriptor.find('.descriptor-btn');
        const fromHeight = pxToVw(descriptor.outerHeight(true));
        const imageHeight = pxToVw(descriptorImage.outerHeight());
        const toHeight = fromHeight + imageHeight;
        gsap.set(descriptorImage, {top: `${fromHeight}vw`});
        let isOpened = false;

        /*
        if(isDesktop()){
            descriptor.on('mouseenter', () => {
                if(!isOpened){
                    animatePlusIcon(descriptorBtn, false, 0.667, 270, 180);
                    gsap.to(descriptor, {
                        height: `${toHeight}vw`,
                        duration: 0.66,
                        ease: 'pageInEasing'
                    })
                }
            })
            descriptor.on('mouseleave', () => {
                if(!isOpened){
                    animatePlusIcon(descriptorBtn, true, 0.667, 270, 180);
                    gsap.to(descriptor, {
                        height: `${fromHeight}vw`,
                        duration: 0.66,
                        ease: 'pageInEasing'
                    })
                }
            });
        } else {
            descriptor.on('click', () => {
                animatePlusIcon(descriptorBtn, isOpened, 0.667, 270, 180);
                gsap.to(descriptor, {
                    height: isOpened ? `${fromHeight}vw` : `${toHeight}vw`,
                    duration: 0.66,
                    ease: 'pageInEasing',
                })
                isOpened =! isOpened;
            })
        }
            */
    })
})